import React from "react";
import { Form, Row, Col, Typography, Button, Icon } from "antd";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import './signin.less'
import Error401 from "../routes/errorPages/401";
import CircularProgress from "components/CircularProgress/index";

const FormItem = Form.Item;
const { Text, Title } = Typography;
const Orion = ['internal_agent', 'partner', 'qa', 'agent', 'admin', 'partner_employee', 'freelancer']
const FC = ['finance_user', 'accounts_user', 'payable_partner_user','client_invoicer']
const PMT = ['project_manager', 'verify_scheduler', 'coordinator', 'client_user', 'client_manager', 'admin', 'client_admin', 'auditor_user','qc', 'kci', 'logistics_user']

const parseAllRolesFromStorage = () => {
  const raw = localStorage.getItem('all_roles');
  if (!raw) return [];

  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) {
      return parsed.map((role) => String(role).trim()).filter(Boolean);
    }
  } catch (err) {
    // fall through to comma-separated parsing
  }

  return raw
    .split(',')
    .map((role) => role.trim().replace(/^["']+|["']+$/g, ''))
    .filter(Boolean);
};

const resolvePortalForRoles = (roles) => {
  const hasOrion = roles.some((role) => Orion.includes(role));
  const hasPmt = roles.some((role) => PMT.includes(role));
  const hasFc = roles.some((role) => FC.includes(role));

  const storedPortal = localStorage.getItem('loged_in_to');
  if (storedPortal === 'orion' && hasOrion) return 'orion';
  if (storedPortal === 'pmt' && hasPmt) return 'pmt';
  if (storedPortal === 'fc' && hasFc) return 'fc';
  if (hasOrion && !hasPmt && !hasFc) return 'orion';
  if (hasPmt && !hasOrion && !hasFc) return 'pmt';
  if (hasFc && !hasOrion && !hasPmt) return 'fc';
  return null;
};

class Interstitial extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      role: parseAllRolesFromStorage(),
      finance: null,
      PMT: null,
      orion: null,
      visibleRole: true,
      logedInUs: null,
    }
    // console.log('props',props.logedInUser)

  }


  capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  componentDidMount = () => {
    const roles = parseAllRolesFromStorage();
    const isFreelancerOnly =
      roles.length === 1 && roles[0] === 'freelancer';

    if (isFreelancerOnly) {
      localStorage.setItem('user_role', 'freelancer');
      localStorage.setItem('loged_in_to', 'orion');
      this.props.history.push('/partner-registration');
      return;
    }

    const portal = resolvePortalForRoles(roles);
    const nextState = { role: roles, logedInUs: portal };

    roles.forEach((role) => {
      if (FC.indexOf(role) >= 0) {
        nextState.finance = role;
      }
      if (Orion.indexOf(role) >= 0) {
        nextState.orion = role;
      }
      if (PMT.indexOf(role) >= 0) {
        nextState.PMT = role;
      }
    });

    this.setState(nextState);
  }

  onClick = (role, type) => {
    localStorage.setItem('user_role', role)
    localStorage.setItem('loged_in_to', type)
    this.setState({ logedInUs: type })

    if (role === 'freelancer') {
      this.props.history.push('/partner-registration');
    }
  }
  showRoles = () => {
    this.setState({ visibleRole: !this.state.visibleRole })
    this.setState({logedInUs:'pmt'})
  }

  getPortalTitle = () => {
    if (this.state.logedInUs === 'pmt') {
      return 'Project Management';
    } else if (this.state.logedInUs === 'orion') {
      return 'Partner Management';
    } else if (this.state.logedInUs === 'fc') {
      return 'Finance Central';
    }
    return 'Matrix';
  }

  getPortalSubtitle = () => {
    if (this.state.logedInUs === 'pmt') {
      return 'Select your role to continue';
    } else if (this.state.logedInUs === 'orion') {
      return 'Select your role to continue';
    } else if (this.state.logedInUs === 'fc') {
      return 'Select your role to continue';
    }
    return 'Choose your portal to get started';
  }

  render() {
    const users = this.state.role.filter((element) => {
      if(this.state.logedInUs === 'pmt'){
        return PMT.includes(element)
      }else if(this.state.logedInUs === 'orion'){
        return Orion.includes(element)
      }else if (this.state.logedInUs === 'fc'){
        return FC.includes(element)
      }else{
        return []
      }
    });

    const portalOptions = [];
    if (this.state.orion) {
      portalOptions.push({
        label: 'Go to Partner Management',
        icon: 'team',
        color: '#630086',
        onClick: () => this.onClick(this.state.orion, "orion"),
        link:
          this.state.orion === 'freelancer'
            ? { pathname: '/partner-registration' }
            : { pathname: '/signin', state: { from: { pathname: this.props?.location?.state?.from?.pathname } } },
        type: 'orion'
      });
    }
    if (this.state.finance) {
      portalOptions.push({
        label: 'Go to Finance Central',
        icon: 'wallet',
        color: '#630086',
        onClick: () => this.onClick(this.state.finance, "fc"),
        link: {pathname: "/signin", state: {from: { pathname: this.props?.location?.state?.from?.pathname } }},
        type: 'fc'
      });
    }
    if (this.state.PMT) {
      portalOptions.push({
        label: 'Go to Project Management',
        icon: 'appstore',
        color: '#630086',
        onClick: this.showRoles,
        link: null,
        type: 'pmt'
      });
    }

    return (
      <div className="gx-app-login-wrap modern-signin-wrapper">
        <div className="gx-app-login-container modern-signin-container">
          <Row type="flex" align="middle" className="gx-app-login-main-content modern-signin-main" gutter={0}>
            <Col xl={12} lg={12} md={12} sm={24} xs={24} className="emptySpacing modern-signin-left">
              <div 
                className="modern-signin-left-bg"
                style={{backgroundColor: '#FAFAFA'}}
              >
                <div className="modern-signin-left-content">
                  <div className="modern-signin-logo -mobile-logo">
                    <img src={require('assets/images/LogoUniserved.png')} alt='Logo' />
                  </div>
                  <h1 className="modern-signin-title">{this.getPortalTitle()}</h1>
                  <p className="modern-signin-subtitle">{this.getPortalSubtitle()}</p>
                  <img src={require('assets/images/Service_Technicians_at_Work.png')} alt='Graphic' className="modern-signin-graphic" />
                </div>
              </div>
            </Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24} className="emptySpacing modern-signin-right">
              <div className="modern-signin-form-container">
                <div className="modern-signin-header">
                  <div className="modern-signin-header-left">
                    <Title level={2} className="modern-signin-header-title">Matrix</Title>
                    <Text className="modern-signin-header-subtitle">Field Services Management</Text>
                  </div>
                  <div className="modern-signin-header-right">
                    <img src={require('assets/images/LogoUniserved.png')} alt='Logo' className="modern-signin-header-logo" />
                  </div>
                </div>
                <div className="modern-signin-form-content">
                  <Title level={1} className="modern-signin-form-title" style={{color: '#262626'}}>
                    {this.state.logedInUs === null ? 'Select Portal' : 'Select Role'}
                  </Title>
                  <Text className="modern-signin-form-text">
                    {this.state.logedInUs === null 
                      ? 'Choose the portal you want to access. Each portal provides different features and capabilities.'
                      : 'Select the role you want to log in with. Your role determines the features and permissions available to you.'}
                  </Text>
                  
                  <div className="modern-interstitial-options">
                    {this.state.logedInUs === null ? (
                      portalOptions.map((option, index) => {
                        const content = (
                          <div className="modern-interstitial-item">
                            <div className="modern-interstitial-item-icon" style={{ backgroundColor: `${option.color}15` }}>
                              <Icon type={option.icon} style={{ color: option.color, fontSize: 24 }} />
                            </div>
                            <span className="modern-interstitial-item-label">{option.label}</span>
                            <Icon type="right" className="modern-interstitial-item-arrow" />
                          </div>
                        );

                        if (option.link) {
                          return (
                            <Link
                              key={index}
                              to={option.link}
                              onClick={option.onClick}
                              className="modern-interstitial-link"
                              style={{ borderLeftColor: option.color }}
                            >
                              {content}
                            </Link>
                          );
                        }

                        return (
                          <a
                            key={index}
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              option.onClick();
                            }}
                            className="modern-interstitial-link"
                            style={{ borderLeftColor: option.color }}
                          >
                            {content}
                          </a>
                        );
                      })
                    ) : (
                      users.length !== 0 ? (
                        users.map((role, index) => (
                          <Link
                            key={index}
                            to={
                              role === 'freelancer'
                                ? { pathname: '/partner-registration' }
                                : { pathname: '/signin', state: { from: { pathname: this.props?.location?.state?.from?.pathname } } }
                            }
                            onClick={() => this.onClick(role, this.state.logedInUs)}
                            className="modern-interstitial-link"
                            style={{ borderLeftColor: '#630086' }}
                          >
                            <div className="modern-interstitial-item">
                              <div className="modern-interstitial-item-icon" style={{ backgroundColor: '#63008615' }}>
                                <Icon type="user" style={{ color: '#630086', fontSize: 24 }} />
                              </div>
                              <span className="modern-interstitial-item-label">
                                Log In as {this.capitalizeFirstLetter(role).replace(/_/g, " ")}
                              </span>
                              <Icon type="right" className="modern-interstitial-item-arrow" />
                            </div>
                          </Link>
                        ))
                      ) : (
                        <Error401/>
                      )
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

const WrappedNormalLoginForm = Form.create()(Interstitial);

const mapStateToProps = ({ auth }) => {
  const { loader, alertMessage, showMessage, authUser, logedInUser } = auth;
  return { loader, alertMessage, showMessage, authUser, logedInUser }
};

export default connect(mapStateToProps,)(WrappedNormalLoginForm);
